import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { AppState } from "../../../../app.reducer";
import { UserDataService } from "../../../../services/user-data.service";

@Component({
  selector: 'app-thanks',
  templateUrl: './thanks.component.html',
  styleUrls: ['./thanks.component.css']
})
export class ThanksComponent implements OnInit {

  public userData: any = {};

  constructor(private router: Router,
              private store: Store<AppState>,
              private userDataService: UserDataService) {
  }

  ngOnInit(): void {
    if (sessionStorage.getItem('insuadvisor_token') === '') {
      this.router.navigate(['login']).then();
    } else {
      this.userData = this.userDataService.loadData();
    }
  }

}
